import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'website';
const pagePrefix = 'admin';
const action = 'TravelButtonInteracted';
const component = 'BookingAssistant';

const actionProps = {
  action,
  category,
  pagePrefix,
  component,
};

const telemObject = createTelemetryObject({
  actions: {
    editItemClicked: (
      page: string,
      args: Readonly<{
        isSuperAdmin: boolean;
        pageSlug: string;
      }>,
    ) => ({
      ...actionProps,
      page,
      label: 'Edit Item Clicked',
      extraInfo: {
        itemType: 'stayBookingAssistantComponent',
        ...args,
      },
    }),
    editItemSubmit: (
      page: string,
      args: Readonly<{
        isSuperAdmin: boolean;
        action: 'added' | 'edited';
        hasPhoto: boolean;
        pageSlug: string;
        mode: string;
        layout?: string;
      }>,
    ) => ({
      ...actionProps,
      page,
      category: 'admin.stayBookingAssistant',
      label: 'Save',
      extraInfo: {
        itemType: 'stayBookingAssistantComponent',
        ...args,
      },
    }),
    editItemCancel: (
      page: string,
      args: Readonly<{
        isSuperAdmin: boolean;
        pageSlug: string;
      }>,
    ) => ({
      ...actionProps,
      page,
      label: 'Edit Item Cancel',
      extraInfo: {
        itemType: 'stayBookingAssistantComponent',
        ...args,
      },
    }),
    deleteItemDialog: (
      page: string,
      args: Readonly<{
        isSuperAdmin: boolean;
        pageSlug: string;
      }>,
    ) => ({
      ...actionProps,
      page,
      label: 'Delete Item Dialog',
      extraInfo: {
        itemType: 'stayBookingAssistantComponent',
        ...args,
      },
    }),
    modeSelectorChanged: (
      page: string,
      args: Readonly<{
        isSuperAdmin: boolean;
        pageSlug: string;
        selectedMode: string;
        previousMode: string;
      }>,
    ) => ({
      ...actionProps,
      page,
      category: 'admin.stayBookingAssistant',
      label: 'Mode Selector Changed',
      extraInfo: {
        itemType: 'stayBookingAssistantComponent',
        ...args,
      },
    }),
    layoutSelectorChanged: (
      page: string,
      args: Readonly<{
        selectedLayout: string;
        previousLayout: string;
      }>,
    ) => ({
      ...actionProps,
      page,
      category: 'admin.stayBookingAssistant',
      label: 'Layout Selector Changed',
      extraInfo: {
        itemType: 'stayBookingAssistantComponent',
        ...args,
      },
    }),
    beginAdding: (page: string, pageSlug: string) => ({
      ...actionProps,
      action: 'beginAdding',
      page,
      label: 'Begin Adding',
      extraInfo: {
        itemType: 'stayBookingAssistantComponent',
        pageSlug,
      },
    }),
  },
});

const { TelemetryProvider: StayBookingAssistantTelemetryProvider, useTelemetry: useStayBookingAssistantTelemetry } = createTelemetry(telemObject);

export { StayBookingAssistantTelemetryProvider, useStayBookingAssistantTelemetry };
